import createClient from "openapi-fetch";
import type { paths } from "@/types/api";
import { ApiError } from "@/lib/api-error";

const client = createClient<paths>({
  baseUrl: import.meta.env.VITE_API_URL ?? "http://localhost:3000",
});

client.use({
  async onRequest({ request }) {
    if (typeof window === "undefined") return request;

    const { getSessionToken } = await import("@/lib/session");
    const token = await getSessionToken();
    if (token) {
      request.headers.set("Authorization", `Bearer ${token}`);
    }
    return request;
  },
});

client.use({
  async onResponse({ response, request }) {
    if (!response.ok) {
      // Read the body exactly once: a Response stream can't be consumed twice,
      // so parse the text instead of trying .json() then .text() on a clone.
      const text = await response.clone().text();
      let body: unknown;
      try {
        body = text ? JSON.parse(text) : null;
      } catch {
        body = text;
      }
      const url = new URL(request.url);
      throw new ApiError(
        `${request.method} ${url.pathname} failed (${response.status})`,
        body,
        {
          status: response.status,
          method: request.method,
          endpoint: url.pathname,
        },
      );
    }
    return response;
  },
});

export default client;
